import DocumentProvider from './documentProvider';

export const getDocumentPreviewsAsync = DocumentProvider.getDocumentPreviewsAsync;

export const deleteDocumentAsync = DocumentProvider.deleteDocumentAsync;

export const insertDocumentAsync = DocumentProvider.insertDocumentAsync;

export const getAllDocumentAsync = DocumentProvider.getAllDocumentAsync;

